import { render, staticRenderFns } from "./WorkshopJob.vue?vue&type=template&id=cb822716&scoped=true&"
import script from "./WorkshopJob.vue?vue&type=script&lang=js&"
export * from "./WorkshopJob.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopJob.vue?vue&type=style&index=0&id=cb822716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb822716",
  null
  
)

export default component.exports